export const CLASS_KEYS = Object.freeze([
    "Package",
    "Resource",
    "Buffer",
    "Texture",
    "ShaderModule",
    "Pipeline",
    "BindGroup",
    "Sampler"
]);
